export default {
  methods: {
    formatDate(date, format, placeholder) {
      const momentDate = this.$moment.utc(date);
      return momentDate.isValid() ?
        momentDate.local().format(format || 'DD-MM-YYYY HH:mm:ss') :
        (placeholder || '-');
    },
    formatDateIgnoreTimezone(date, format, placeholder) {
      const momentDate = this.$moment(date);
      return momentDate.isValid() ?
        momentDate.format(format || 'DD-MM-YYYY HH:mm:ss') :
        (placeholder || '-');
    },
    currentDateFormatted(format) {
      return this.$moment().format(format || 'DD-MM-YYYY HH:mm:ss');
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/dateMixin.js